import {
  HapticFeedbackConfig,
  playHapticFeedback,
} from "@/bridge/playHapticFeedback";
import { usePersistentDataState } from "./usePersistentDataState";

export function useHapticFeedback() {
  const [vibrationEnabled] = usePersistentDataState("vibrationEnabled", true);

  if (vibrationEnabled === undefined) {
    return undefined;
  }

  return (config: HapticFeedbackConfig) => {
    if (vibrationEnabled) {
      playHapticFeedback(config);
    }
  };
}
